// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"92dac437","665":"3d403427","705":"be022f48","740":"c7da79a3"}[chunkId] + ".chunk.js";
};